<script>
  import FormsTable from '../account/forms-table.svelte';

  export let forms = [];
  export let siteCount = 0;
  export let sid;
  export let returnTo;
</script>

<FormsTable {forms} {siteCount} {returnTo} {sid} />
